import { ServerMachineInfo } from '@/api/type-server'
import { MachineType } from '@/consts/machine'

export function formatMachineName(
  machineType: MachineType,
  unitSpec: ServerMachineInfo['unitSpec'],
) {
  const hostType = machineType

  if (hostType === MachineType.CPU && unitSpec?.cpuName) {
    return unitSpec.cpuName
  }

  return unitSpec?.gpuName.replace(/(\(R\)|@\s.*GHz)/g, '') ?? ''
}

export function getCpuAlias(cpuName: string) {
  return cpuName
    .replace(/@.*$/, '')
    .replace(/Intel\(R\)/, '')
    .replace(/\(TM\)|\(R\)/, '')
    .replace(/[ ]CPU/, '')
    .trim()
}

export function getCpuName(cpuIds: number[], cpuName: string, unitNum = 1, multiChar = '×') {
  const cpuAlias = getCpuAlias(cpuName)
  return `${cpuIds.length * unitNum}${multiChar} ${cpuAlias}`
}

export function formatHwConfig(unitSpec: ServerMachineInfo['unitSpec']) {
  const { cpuCores, cpuName, ramMB, diskGB } = unitSpec || {}
  const cpuRamGB = Math.ceil(ramMB / 1024)
  const { gpuRamMB, gpuName } = unitSpec || {}
  const gpuRamGB = Math.ceil(gpuRamMB / 1024)

  return {
    cpuCores,
    cpuRamGB,
    diskGB,
    cpuName,
    gpuName,
    gpuRamGB,
  }
}

/**
 * @deprecated
 */
export function formatOldMachineName(hardware: any) {
  const hostType = getOldHostType(hardware)

  const { gpu, machine, npu } = hardware || {}

  if (hostType === MachineType.GPU && gpu?.gpuName) {
    return gpu.gpuName
  }

  if (hostType === MachineType.NPU && npu?.npuName) {
    return npu.npuName
  }

  return machine?.cpuName.replace(/(\(R\)|@\s.*GHz)/g, '')
}

/**
 * @deprecated
 */
export function getOldHostType(hardware: any) {
  const { gpu, npu } = hardware || {}

  if ((npu?.npuIds?.length ?? 0) > 0) {
    return MachineType.NPU
  }
  if ((gpu?.gpuIds?.length ?? 0) > 0) {
    return MachineType.GPU
  }
  return MachineType.CPU
}
